module.exports = __webpack_public_path__ + "img/amarone.559190b6.jpg";